import React, { useEffect } from 'react'
import classes from '../styles.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import IndicatorsPage from '../../../indicators/indicators.page';
import MenuHeader from './menu-header.component';
import GeoportalPage from '../../../geoportal/geoportal.pages';
import SettingsSelector from '../../../settings/settings.page';
import ProjectsPage from '../../../projects/projects.page';
import ImprovementProjectsTab from '../../../projects/tabs/improvement-projects-tab.component';
import SnpInfo from '../../../indicators/components/snp-info.component';
import { getKatoType } from '../../../../helpers/utils';
import { KatoType } from '../../../../types/kato.types';
import { getModules } from '../../../../requests/super-admin.request';
interface IProps {
  setIsOpen: (isOpen: boolean) => void;
}

const RightMenu: React.FC<IProps> = ({ setIsOpen }) => {
  const { kato, link } = useParams<{ link: string, kato: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!kato || !link) return;
    const katoType = getKatoType(kato) as KatoType.VILLAGE | KatoType.OBLAST;
    const katoTypeVal = katoType === KatoType.VILLAGE ? KatoType.VILLAGE : KatoType.OBLAST;
    getModules()
      .then((modules) => {
        if (modules) {
          if (!modules[katoTypeVal]?.includes(link) && link !== 'settings') navigate(`/${kato}`);
        }
      })

  }, [kato]);

  return (
    <div className={classes['right-menu']}>
      <MenuHeader setIsOpen={setIsOpen} />
      {link === 'indicators' && <IndicatorsPage />}
      {link === 'projects' && <ProjectsPage />}
      {link === 'geoportal' && <GeoportalPage />}
      {link === 'settings' && <SettingsSelector />}
      {link === 'SNP_IMPROVEMENT' && <ImprovementProjectsTab />}
      {link === 'snp-info' && <SnpInfo />}
    </div>
  )
}

export default RightMenu